















































import { ICategory } from "@/@types/menu/menu/menu";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class SortProductByCategory extends Vue {
  @Prop({ type: Array, default: () => [] }) categoryList!: Array<ICategory>;
  @Prop({ type: Boolean, default: true }) showAddButton!: boolean;
  categorys: string | null | undefined = null;

  getCategoryName(category: string): string {
    const cat = this.categoryList.find((el) => category == el._id);
    if (cat) return this.$getLocale(cat.name);
    else return category;
  }
}
